import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { SendPackageSummaryComponent } from 'src/app/patch-management/send-package-dialog/send-package-summary-dialog/send-package-summary.component';
import { SendPackageSuccessDialogComponent } from 'src/app/patch-management/send-package-dialog/send-package-success-dialog/send-package-success-dialog.component';
@Injectable({
  providedIn: 'root',
})
export class ConnectivityStatusService {
  constructor(public dialog: MatDialog){
  }
  public connectivityStatus = new Subject<any>();
  public fileUploadAcceptance = new BehaviorSubject<any>({});
  public fileProgressResponse = new BehaviorSubject<any>({});
  public deploymentResponse = new BehaviorSubject<any>({});
  public loginActivity = new Subject<any>();
  public packageUploadResponse = new Subject<any>();
  private hubConnection: signalR.HubConnection | undefined;
  public startConnection = () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(environment.realizerUrl + 'deviceConnection')
      .withAutomaticReconnect()
      .build();
    this.hubConnection
      .start()
      .then(() => console.log('Connection started'))
      .catch((err) => console.log('Error while starting connection: ' + err));
  };

  public connectivityStatusListener = () => {
    return this.hubConnection?.on("devicehealth", (data) => {
      this.connectivityStatus.next(data);      
    });
  };
  public deploymentResponseListener = () => {
    return this.hubConnection?.on("DeploymentResponse", (data) => {
      this.deploymentResponse.next(data);      
    });
  };

  public fileUploadStatusListener = () => {
    return this.hubConnection?.on("FileUploadAcceptance", (data) => {
      this.fileUploadAcceptance.next(data);
    });
  };

  public fileProgressResponseListener = () => {
    return this.hubConnection?.on("FileProgressResponse", (data) => {
      this.fileProgressResponse.next(data);
    });
  };
  public userSignInListner = () => {
    return this.hubConnection?.on("LoginNotification", (data) => {
      this.loginActivity.next(data);
    });
  };
  public packageUploadStatus = () => {
    return this.hubConnection?.on("PackageUploadResponse", (data) => {
      this.packageUploadResponse.next(data);
    });
  };
  public getConnectivityStatus() {
    return this.connectivityStatus.asObservable();
  }

  public getFileUploadStatus() {
    return this.fileUploadAcceptance.asObservable();
  }

  public getFileProgressResponse() {
    return this.fileProgressResponse.asObservable();
  }
  public getLoginActivity() {
    return this.loginActivity.asObservable();
  }
  public getPackageUploadResponse() {
    return this.packageUploadResponse;
  }
  public stopConnection(){
    this.hubConnection?.stop()
    .then(() => console.log('Connection stoped'))
    .catch((err) => console.log('Error while stopping connection: ' + err));
  }
}


export enum FileUploadStatus {
  DefaultState = 0,
  Initiate = 1,
  Accepted = 2,
  Started = 3,
  Completed = 4,
  Failed = 5
}